module.exports = __webpack_public_path__ + "sunsemweb/img/sf2.32420aed.png";